export const checkResponseErrorCodeAndRedirect = (err) => {
  if(err && err.response && err.response.status === 403) {
    sessionStorage.removeItem('jwtToken');
    window.location = '/';
  }
}
